<template>
    <div class="HumandirectoryBox">
        <div class="nav">
            <router-link to='Home'><img src="../../assets/up.png" alt="" class="Left"> </router-link> 行政管理制度与流程
            <img src="../../assets/search.png" alt="" class="RIght" @click="getOnPage">
        </div>
        <img v-for="item in dataImg" :key="item.id" :src="item.images" alt="" class="Img" @click="BtnIssue(item.id)">
    </div>
</template>

<script>
export default {
    data(){
        return {
            dataImg:[
            {images:'http://file.xdf.cn/uploads/191008/1369_20191008104701.png', id:'1'},
            {images:'http://file.xdf.cn/uploads/191008/1369_20191008104735.png', id:'2'},
            {images:'http://file.xdf.cn/uploads/191029/1369_20191029155925.png', id:'3'},
            {images:'http://file.xdf.cn/uploads/191029/1369_20191029155945.png', id:'4'},
            {images:'http://file.xdf.cn/uploads/191029/1369_20191029160016.png', id:'5'},
            {images:'http://file.xdf.cn/uploads/191029/1369_20191029160031.png', id:'6'}]
        }
    },
    methods:{
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "q"
                }
            })
        },
        BtnIssue(id){
            if(id == 1){
                this.$router.push({name: 'IssueManpower3'})
            } else if(id == 2){
                this.$router.push({name: 'Scene3'})
            } else if(id == 3){
                this.$router.push({name: 'Administrative1'})
            } else if(id == 4){
                this.$router.push({name: 'Administrative'})
            } else if(id == 5){
                this.$router.push({name: 'Administrative10'})
            } else if(id == 6) {
                this.$router.push({name:"Administrative7"})
            }
        }
    }
}
</script>

<style>
.nav {
  width: 100%;
  height: 3.7rem;
  text-align: center;
  line-height: 3.7rem;
  background: #11a093;
  color: #FFFFFF;
  font-size: 16px;
  position: relative;
}
.Img {
    width: 45%;
    display: block;
    float: left;
    margin-left: 3%;
    margin-top: 1rem;
}
.RIght, .Left {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto
}
.RIght{
    width: 1.1rem;
    float: right;
    right: 15px;
}
.Left {
    height: 1.2rem;
    float: left;
    left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Administrative/administrativeHome.vue